/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { FiltersProp } from "~/models/estateRecordRow";

export enum ACTION {
  CLEAR = "CLEAR",
  UPDATE = "UPDATE",
  UPDATE_ALL = "ACTIVE",
}

type Action =
  | {
      type: ACTION.CLEAR;
    }
  | {
      type: ACTION.UPDATE_ALL;
      payload: {
        filters: FiltersProp;
      };
    }
  | {
      type: ACTION.UPDATE;
      payload: {
        filters: FiltersProp;
      };
    };

export const reducer = (state: FiltersProp, action: Action): FiltersProp => {
  switch (action.type) {
    case ACTION.CLEAR:
      return {};

    case ACTION.UPDATE:
      return {
        ...state,
        ...action.payload.filters,
      };

    case ACTION.UPDATE_ALL:
      return {
        ...action.payload.filters,
      };

    default:
      throw new Error(`Unknown action: ${action}`);
  }
};
